module.exports = __webpack_public_path__ + "static/img/shipintonghua@2x.0f9abe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/gallery/shipintonghua@2x.png
// module id = AVeX
// module chunks = 1